import { motion } from "framer-motion";
import { resolveImg } from "@/lib/api";

export const Testimonials = ({ testimonials }) => {
  if (!testimonials || testimonials.length === 0) return null;

  return (
    <section id="resultados" data-testid="testimonials-section" className="bg-sand-100 py-24 md:py-32">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-xs tracking-[0.25em] uppercase font-semibold text-terracotta-500">Resultados Reales</span>
          <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl font-light tracking-tight text-forest-900 mt-4 leading-[1.05]">
            Testimonios de nuestros clientes
          </h2>
          <p className="text-forest-700/70 mt-5">Transformaciones reales de personas que confiaron en los productos Vida Divina.</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {testimonials.map((t, i) => (
            <motion.div
              key={t.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.08 }}
              data-testid={`testimonial-${t.id}`}
              className="group relative rounded-2xl overflow-hidden aspect-[3/4] bg-forest-900 shadow-[0_8px_32px_rgba(26,54,38,0.08)]"
            >
              <img src={resolveImg(t.image)} alt={t.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-forest-900/90 via-transparent to-transparent" />
              <div className="absolute bottom-0 inset-x-0 p-4 text-sand">
                <div className="text-xs uppercase tracking-widest text-terracotta-300">{t.caption}</div>
                <div className="font-serif text-lg mt-1 leading-tight">{t.name}</div>
                {t.result && <div className="text-sand/80 text-sm mt-0.5">{t.result}</div>}
              </div>
            </motion.div>
          ))}
        </div>
        <p className="text-center text-forest-700/50 text-xs mt-10 max-w-2xl mx-auto">
          * Los resultados individuales pueden variar. Dependen del peso inicial, tipo de cuerpo, ejercicio y dieta.
        </p>
      </div>
    </section>
  );
};
